import { CONSTANTS, HELPER } from '../../utils'
import { CART_CONSTANTS, CONFIG_CONSTANTS, DIALOG_CONSTANTS, LANG_CONSTANTS } from '../actionTypes'

const initState = {
	// POPUP
	setOpen: false,
	popupType: CONSTANTS.POPUP_TYPE.TERMS,

	//Default Language
	openLangPopup: false,
	locale_updated: false,

	showCartMenu: false,
	showProductDetail: false,
	buyNowClicked: false,
}

const actionReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case DIALOG_CONSTANTS.TERMS_OPEN:
			return { ...state, setOpen: true, showCartMenu: false, popupType: action.response }
		case DIALOG_CONSTANTS.TERMS_CLOSE:
			return { ...state, setOpen: false }
		case CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT:
			return initState
		case LANG_CONSTANTS.LANGUAGE_POPUP_OPEN:
			return {
				...state,
				openLangPopup: true,
				locale_updated: false,
			}
		case LANG_CONSTANTS.LANGUAGE_POPUP_CLOSE:
			return { ...state, openLangPopup: false, locale_updated: false }
		case LANG_CONSTANTS.UPDATE_LANGUAGE_LOCALE:
			return { ...state, locale_updated: false }
		case LANG_CONSTANTS.SET_LANGUAGE_LOCALE:
			return { ...state, locale_updated: true }

		case CART_CONSTANTS.CART_MENU_OPEN_REQUEST:
			return { ...state, showCartMenu: !state?.showCartMenu, setOpen: false }
		case DIALOG_CONSTANTS.PRODUCT_DETAIL_OPEN:
			return {
				...state,
				buyNowClicked: false,
				showProductDetail: !state?.showProductDetail,
				setOpen: false,
				showCartMenu: false,
			}
		case DIALOG_CONSTANTS.PRODUCT_BUY_NOW_CLICKED:
			return {
				...state,
				buyNowClicked: true,
			}
		case CART_CONSTANTS.CHANGE_ITEM_QTY_IN_CART:
			return {
				...state,
				showProductDetail: HELPER.isNotEmpty(action?.cart?.cart_items)
					? state?.showProductDetail
					: false,
			}
		case CART_CONSTANTS.REMOVE_ITEM_FROM_PRODUCT_ITEM:
			return {
				...state,
				showProductDetail: state?.showProductDetail ? false : state?.showProductDetail,
			}
		default:
			return state
	}
}
export default actionReducer
